export default function formatDecimal(amount, decimals = 2) {
  if (!amount) return 0;
  return amount.toFixed(decimals);
}
